import { __awaiter, __generator } from "tslib";
import { combine, isUrlAbsolute, objectDefinedNotNull, RuntimeConfig, stringIsNullOrEmpty } from "@pnp/common";
import { GraphRuntimeConfig } from "../graphlibconfig";
/**
 * Ensures that a given url is absolute for the current web based on context
 *
 * @param candidateUrl The url to make absolute
 *
 */
export function toAbsoluteUrl(candidateUrl) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var client, baseUrl, e_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (isUrlAbsolute(candidateUrl)) {
                        // if we are already absolute, then just return the url
                        return [2 /*return*/, candidateUrl];
                    }
                    if (!stringIsNullOrEmpty(GraphRuntimeConfig.baseUrl)) {
                        // base url specified either with baseUrl of spfxContext config property
                        return [2 /*return*/, combine(GraphRuntimeConfig.baseUrl, candidateUrl)];
                    }
                    if (!objectDefinedNotNull(RuntimeConfig.spfxContext)) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, RuntimeConfig.spfxContext.msGraphClientFactory.getClient()];
                case 2:
                    client = _c.sent();
                    baseUrl = (_b = (_a = client) === null || _a === void 0 ? void 0 : _a.constructor) === null || _b === void 0 ? void 0 : _b._graphBaseUrl;
                    if (!stringIsNullOrEmpty(baseUrl)) {
                        return [2 /*return*/, combine(baseUrl, candidateUrl)];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _c.sent();
                    return [3 /*break*/, 4];
                case 4: 
                // try one last time with the default
                return [2 /*return*/, combine("https://graph.microsoft.com", candidateUrl)];
            }
        });
    });
}
//# sourceMappingURL=toabsoluteurl.js.map